import React, {Component} from 'react';
import {connect} from 'react-redux';
import {NavLink, withRouter} from 'react-router-dom';

import {Dropdown, Menu} from 'semantic-ui-react';

class PortfolioMenu extends Component {

    shouldComponentUpdate({location: {
            pathname
        }}) {
        return pathname !== this.props.location.pathname;
    }

    render() {
        // console.log('PortfolioMenu render');
        const {routes} = this.props;
        return <Menu.Menu>
            <Menu.Item as={NavLink} exact={true} to={`${routes.portfolio}/`}>
                <span role="img" aria-label="Home">
                    👨🏼
                </span>
            </Menu.Item>
            <Dropdown item={true} className='PortfolioMenu' text="Portfolio">
                <Dropdown.Menu>
                    <Dropdown.Item as={NavLink} to={routes.clientReddit} text='Reddit Client'/>
                    <Dropdown.Item as={NavLink} to={routes.scenePlanet} text='Planet Scene'/>
                    <Dropdown.Item as={NavLink} to={`${routes.portfolio}/notifications`} text='Notifications'/>
                </Dropdown.Menu>
            </Dropdown>
        </Menu.Menu>;
    }
}

const connectedMenu = connect(({routes}) => ({routes}))(PortfolioMenu);
export default withRouter(connectedMenu);


// WEBPACK FOOTER //
// ./src/apps/portfolio/components/Menu.js